<template>
    <div>
        <Header :type="2" :sub-type="6"></Header>
        <div class="banner"></div>
        <Scenarios></Scenarios>
        <Advantage></Advantage>
    </div>
</template>
<script>
import Header from '../../components/header.vue'
import Scenarios from './scenarios.vue'
import Advantage from './advantage.vue'
export default {
    name: "cloudWarehouse",
    components: {
        Header,
        Scenarios,
        Advantage
    },
}
</script>
<style lang="less" scoped>
@import "../../assets/style/utils.less";
.banner {
    height: 25vw;
    width: 100%;
    background-image: url('../../../static/images2/cloud_warehouse_banner.webp');
    background-color: #ebf2fe;
    background-repeat: no-repeat;
    background-size: cover;
}
@media screen and (max-width: 900px) {
  .banner {
    height: .h5px2vw(703)[@result];
    background-image: url('../../../static/images2/h5/cloud_warehouse_banner.webp');
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/cloudWarehouse/index.vue